(function() {
'use strict';

angular.module('TR')
    .directive('acceptCookiesBanner', ($timeout, cookieService) => ({
        restrict: 'E',
        replace: true,
        templateUrl: 'partials/home/directivetemplate?type=acceptcookiesbanner',
        controllerAs: 'ac',
        controller($rootScope) {
            const cookiesAccepted = cookieService.get('CookiesAccepted') || false;

            this.hide = cookiesAccepted;
            this.if = !cookiesAccepted;

            this.acceptCookies = function() {
                cookieService.set('CookiesAccepted', true, Infinity);
                this.if = false;
                $timeout(() => this.if = false, 1000);
                $rootScope.$emit('cookiesAccepted');
            };
        }
    }));
})();
